/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScanActivationQrResponse
 */
export interface ScanActivationQrResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ScanActivationQrResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScanActivationQrResponse
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScanActivationQrResponse
     */
    objectiveComplete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScanActivationQrResponse
     */
    activationComplete?: boolean;
}

/**
 * Check if a given object implements the ScanActivationQrResponse interface.
 */
export function instanceOfScanActivationQrResponse(value: object): value is ScanActivationQrResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ScanActivationQrResponseFromJSON(json: any): ScanActivationQrResponse {
    return ScanActivationQrResponseFromJSONTyped(json, false);
}

export function ScanActivationQrResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScanActivationQrResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'objectiveComplete': json['objectiveComplete'] == null ? undefined : json['objectiveComplete'],
        'activationComplete': json['activationComplete'] == null ? undefined : json['activationComplete'],
    };
}

export function ScanActivationQrResponseToJSON(json: any): ScanActivationQrResponse {
    return ScanActivationQrResponseToJSONTyped(json, false);
}

export function ScanActivationQrResponseToJSONTyped(value?: ScanActivationQrResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'objectiveComplete': value['objectiveComplete'],
        'activationComplete': value['activationComplete'],
    };
}

